import loggerService from '@/services/logger.service';
import store from '@/store';

export enum EmbeddedMessageTypeEnum {
  USER_INFO = 'gc-user-info',
  LOGOUT_USER = 'gc-logout'
}

type UserMessagePayload = {
  email: string;
  name: string;
  id: string;
};

type WindowMessage = {
  type: EmbeddedMessageTypeEnum;
  data: UserMessagePayload | null;
};

function getUserInfoPayload(): WindowMessage | null {
  const currentUser = store.getters.getCurrentUser;
  if (!currentUser) {
    loggerService.error('[EmbeddedEventService] User not found');
    return null;
  }

  const userName = currentUser?.name ?? currentUser?.first_name + ' ' + currentUser?.last_name;
  return {
    type: EmbeddedMessageTypeEnum.USER_INFO,
    data: {
      email: currentUser?.email,
      name: userName,
      id: currentUser?.id
    }
  };
}

function getLogoutUserPayload(): WindowMessage {
  return {
    type: EmbeddedMessageTypeEnum.LOGOUT_USER,
    data: null
  };
}

export default function sendEmbeddedEventMessage(messageType: EmbeddedMessageTypeEnum) {
  try {
    loggerService.info('SendEmbeddedEventMessage', messageType);
    switch (messageType) {
      case EmbeddedMessageTypeEnum.USER_INFO:
        window.parent.postMessage(getUserInfoPayload() ?? {}, '*');
        break;
      case EmbeddedMessageTypeEnum.LOGOUT_USER:
        window.parent.postMessage(getLogoutUserPayload() ?? {}, '*');
        break;
      default:
        break;
    }
  } catch (error) {
    loggerService.error('Error sending embedded event message', error);
  }
}
